import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { UserDevice, UserDeviceCreate, UserDeviceFilter } from '../data/userDevice';

export function createUserDeviceService(client: AxiosInstance) {
  return createCrudService<UserDevice, UserDeviceCreate, UserDeviceFilter>(
    client,
    '/identity/UserDevice',
    'id',
  );
}

export type UserDeviceService = CrudService<UserDevice, UserDeviceCreate, UserDeviceFilter>;
